import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronUp } from "lucide-react";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  // Page change hone par top par le jayega
useEffect(() => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}, [pathname]);
  // Scroll button show/hide
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Button click
  const backToTop = () => {
  const start = window.pageYOffset;
  const duration = 4000; // 1.5 second (increase for slower scroll)
  let startTime = null;

  const easeInOutCubic = (t) => {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };

  const animateScroll = (currentTime) => {
    if (!startTime) startTime = currentTime;

    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    window.scrollTo(0, start * (1 - easeInOutCubic(progress)));

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
};

  return (
    <>
      <style>
        {`
          .scroll-top-btn{
              position:fixed;
              right:25px;
              bottom:30px;
              width:55px;
              height:55px;
              border:none;
              border-radius:50%;
              background:#0A2E73;
              color:#fff;
              display:flex;
              justify-content:center;
              align-items:center;
              cursor:pointer;
              box-shadow:0 10px 25px rgba(0,0,0,.25);
              transition:.35s ease;
              z-index:9999;
              animation:fadeIn .3s ease;
          }

          .scroll-top-btn:hover{
              background:#FFD700;
              color:#0A2E73;
              transform:translateY(-6px) scale(1.08);
          }

          @keyframes fadeIn{
              from{
                  opacity:0;
                  transform:translateY(20px);
              }
              to{
                  opacity:1;
                  transform:translateY(0);
              }
          }

          @media(max-width:768px){
              .scroll-top-btn{
                  width:48px;
                  height:48px;
                  right:18px;
                  bottom:20px;
              }
          }
        `}
      </style>

      {showButton && (
       <button className="scroll-top-btn" onClick={backToTop}>
  <ChevronUp size={28} />
</button>
          
      )}
    </>
  );
};

export default ScrollToTop;